import Vue from 'vue'
import VueRouter from 'vue-router'
import list from '../view/List.vue'
import test from '../view/test.vue'
import slider from '../components/Slider/index.vue'
import CreateRule from "../view/CreateRule.vue";

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     // component: slider,
    //     redirect:'/list',
    //     children:[
    //         {
    //             path: '/list',
    //             name: 'list',
    //             component: list
    //         },
    //         {
    //             path: '/test',
    //             name: 'test',
    //             component: test
    //         }
    //     ]
    // },
    {
        path: '/',
        name:'list',
        component:list,
    },
    {
        path: '/test',
        name:'test',
        component:test,
    },
    {
        path: '/createRule',
        name:'CreateRule',
        component: CreateRule
    },

]

const router = new VueRouter({
    routes: [
        ...routes
    ]
})
export default router
